import moment from 'moment'
import 'moment/locale/de'
import { enumvaluetranslations } from './enumvaluetranslations'

moment.locale('de')

/**
 * Turns an array of transactions into a json formatted csvData array
 * @param {object[]} transactions array of objects depicting transactions
 */
const getCsvDataForAllTransactions = (transactions) => {
    let csvData = []
    transactions.forEach(x => {
        x.Articles.forEach(y => {
            let sizeString = ""
            y.Sizes.forEach(size => sizeString += (size.SizeValue + ": " + size.Amount + ", "))
            let total = y.Sizes.map(size => size.Amount).reduce((a, b) => a + b)
            csvData.push({
                "Lieferung an": x.SourceOrTargetName,
                "Datum": moment(x.CreationDate, "DD.MM.YYYY"),
                "Status": enumvaluetranslations(x.State),
                "Bemerkung": x.Remark,
                "Artikelnr.": y.ArticleIdFaex,
                "Artikelname": y.Name,
                "Farbe": y.Colour,
                "Vk-Preis": y.SalePrice,
                "Größen": sizeString,
                "Total": total
            })
        })
    })
    return (csvData)
}

/**
 * Turns an array of articleTypes into a json formatted csvData array
 * @param {object[]} articleTypes array of objects depicting articleTypes
 */
const getCsvDataForAllArticleTypes = (articleTypes) => {
    let csvData = []
    articleTypes.forEach(x => {
        csvData.push({
            "Artikelnr. Designer": x.ArticleNumberDesigner,
            "Artikelnr. FAEX": x.ArticleIdFaex,
            "Name": x.Name,
            "Farbe": x.ColourDescription !== undefined ? x.ColourDescription.ColourName : "",
            "Geschlecht": x.Sexes,
            "Größenkategorie": x.SizeAttribute.SizeCategory,
            "Beschreibung": x.DescriptionDesigner,
            "Vk-Preis": x.SalePrice,
        })
    })
    return (csvData)
}

/**
 * Turns an array of articles into a json formatted csvData array
 * @param {object[]} stock array of objects depicting articles
 */
const getCsvDataForArticleStock = (stock) => {
    let csvData = stock.map(x =>
    ({
        "Artikelnr. Designer": x.ArticleNumberDesigner,
        "Artikelnr. FAEX": x.ArticleIdFaex,
        "Artikelname": x.Name,
        "Farbe": x.Colour,
        "Beschreibung": x.DescriptionDesigner,
        "Größe": x.Size,
            "Gesamt": x.ArticleStock.Total,
            "Extern": x.ArticleStock.External,
            "Verkauft": x.ArticleStock.Sold,
            "Lager": x.ArticleStock.Storage,
        "Vk-Preis": x.SalePrice,
    }))
    return (csvData)
}

const getCsvDataForSingleTransaction = (articles, sizeCategories) => {
    let csvArrayData = []

    sizeCategories.forEach(x => {

        let csvData = []
        articles
            .filter(y => y.SizeCat === x).forEach(article => {
                let object =
                {
                    "Artikelnr. FAEX": article.ArticleIdFaex,
                    "Artikelnr. Designer": article.ArticleNumberDesigner,
                    "Artikelname": article.Name,
                    "Größenkategorie": x,
                    "Farbe": article.Colour,
                    "Vk-Preis": article.SalePrice,
                }
                article.Sizes.forEach(size => {
                    let key = size.SizeValue.toString() + " "
                    let value = size.Amount
                    let sizePair = { [key]: value }

                    object = { ...object, ...sizePair }
                })

                let numbers = article.Sizes.map(entry => parseInt(entry.Amount))
                let total = 0
                numbers.map(number => total = parseInt(total) + parseInt(number))
                let totalPair = { "Total": total }
                object = { ...object, ...totalPair }

                csvData.push(object)
            }
        )
        csvArrayData.push(csvData)
    })
    return (csvArrayData)
}

const getCsvDataForSalesReport = (salesReport) => {
    let csvData = salesReport.map(x =>
    ({
        "Verkaufsstelle": x.SalesPoint,
        "Verkaufsdatum": x.Date,
        "Artikelnr. FAEX": x.FAEXArticleNumber,
        "Artikelnr. Designer": x.ArticleNumberDesigner,
        "Artikelname": x.ArticleName,
        "Farbe": x.Colour,
        "Größe": x.Size,
        "Anzahl": x.Amount,
        "Originalpreis": x.SalesPrice,
        //"Zahlung brutto an Designer (60 %)": x.PaymentForFAEXBrutto,
        //"Zahlung netto an Designer": x.PaymentForFAEXNetto
    }))
    return (csvData)
}

const getCsvFileName = (name, date, deliveryName) => {
    return (date.replace(".", "-") + name + deliveryName)
}

export {
    getCsvDataForAllTransactions, getCsvDataForAllArticleTypes, getCsvDataForArticleStock, getCsvDataForSingleTransaction,
    getCsvDataForSalesReport,
    getCsvFileName
}